export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: () => ({
    schedule_publish_dates: false,
    publish_start: null,
    publish_stop: null,
    never_unpublish: true,
    published: false,
  }),
  methods: {
    preparePublishSettings() {
      if (!this.item) {
        return;
      }

      this.published = this.item.published;

      if (this.item.publish_start || this.item.publish_stop) {
        this.publish_start = this.item.publish_start;
        if (this.item.publish_stop) {
          this.publish_stop = this.item.publish_stop;
          this.never_unpublish = false;
        } else {
          this.never_unpublish = true;
        }
        this.schedule_publish_dates = true;
      }
    },
  },
  watch: {
    never_unpublish: function (newValue) {
      if (newValue) {
        this.publish_stop = null;
      }
    },
  },
};
